module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_basic"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('div', {
    staticClass: "tea_li"
  }, [_c('div', {
    staticClass: "tea_li_l2"
  }, [_c('div', {
    staticClass: "tea_lititle"
  }, [_vm._v(_vm._s(_vm.teacher.nameEn) + " " + _vm._s(_vm.teacher.nameCh))]), _vm._v(" "), _vm._l((_vm.teacher.background), function(background, index) {
    return _c('div', {
      key: index,
      staticClass: "tea_tx"
    }, [_c('span', {
      staticClass: "tea_tg"
    }, [_vm._v(_vm._s(_vm.showDegree(background)))]), _vm._v(" " + _vm._s(_vm.showSchool(background)) + ", " + _vm._s(background.graduation_year) + "\n        ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_tx mt15"
  }, [_vm._v(_vm._s(_vm.showPage.officeLocation) + " : " + _vm._s(_vm.teacher.office))]), _vm._v(" "), _c('div', {
    staticClass: "tea_tx"
  }, [_vm._v(_vm._s(_vm.showPage.tel) + " : " + _vm._s(_vm.teacher.tel))]), _vm._v(" "), _c('div', {
    staticClass: "tea_tx"
  }, [_vm._v("Email : " + _vm._s(_vm.teacher.email))]), _vm._v(" "), _c('div', {
    staticClass: "tea_tx"
  }, [_vm._v(_vm._s(_vm.showPage.consultationTime) + " : " + _vm._s(_vm.teacher.advisory))]), _vm._v(" "), _c('div', {
    staticClass: "tea_tx"
  }, [_vm._v(_vm._s(_vm.showPage.personalWebpage) + " : " + _vm._s(_vm.teacher.website))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "15px",
      "border-bottom": "#ddd 1px solid"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_tx mt15"
  }, [_vm._v(_vm._s(_vm.showTitle(_vm.teacher.title)))]), _vm._v(" "), _vm._l((_vm.teacher.subTitle), function(subTitle, index) {
    return _c('div', {
      key: index,
      staticClass: "tea_tx"
    }, [_vm._v(_vm._s(subTitle))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tea_li_r2"
  }, [(_vm.teacher.profileImage) ? _c('img', {
    attrs: {
      "src": _vm.teacher.profileImage
    }
  }) : _c('img', {
    attrs: {
      "src": "/../static/images/timeline-default-photo.gif"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_title"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.showPage.researchArea))]), _vm._v(" "), _vm._l((_vm.teacher.researchArea), function(researchArea, index) {
    return _c('div', {
      key: index,
      staticClass: "tea_tx"
    }, [_vm._v(_vm._s(_vm.showResearchArea(researchArea)))])
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_title"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.showPage.researchSummary))]), _vm._v(" "), _c('div', {
    staticClass: "tea_tx",
    domProps: {
      "innerHTML": _vm._s(_vm.showResearchSummary())
    }
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08b0a45c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TeacherBasic.vue
// module id = 1183
// module chunks = 4